import { createContext } from 'react';
import { SelectableToggleBoxProps } from './SelectableToggleBox';

type SelectableToggleBoxContextValue = {
	size?: SelectableToggleBoxProps['size'];
};

export const SelectableToggleBoxContext = createContext<SelectableToggleBoxContextValue>({});
